export const coveredCostsDocumentsSelector = ({
  activeIds,
  fulfillStipulation,
  stipulations,
  uploadDocument,
}) => ({
  hasServerError: fulfillStipulation?.error || !!uploadDocument?.error,
  stipulation: stipulations?.allStipulations?.find(({ id }) => id === activeIds.stipulationId),
});
